/* Built In Imports */
import { forwardRef, useState } from 'react';

/* External Imports */
import {
    Box,
    Button,
    Flex,
    FormControl,
    Grid,
    Link,
    ListItem,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Text,
    UnorderedList,
    useMultiStyleConfig,
    useTab, Image
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import parser from 'html-react-parser';
import { nanoid } from 'nanoid';  
import forEach from 'lodash/forEach';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import SingleImage from '@components/Card/SingleImage';
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import HtmlBlock from '@components/UI/HtmlBlock';

/* Services */
/**
 *
 * @param {object} section
 * @returns EventProgramDetails
 */
export const pageCss = {
    en: {
        tabTitle: {
        fontSize: {
            base: '16px',
            md: '22px',
        },
        color: 'red',
        },
        testimonialHeight: 571,
        cardTitle: {
        lineHeight: {
            base: '1.5rem',
            md: '1.6rem',
        },
        },
    },
};

const ProgramCategory = ({ section, region, lang, csrData }) => {   
    const [prgUrl, setPrgUrl] = useState('');
    const [onlinePrgUrl, setOnlinePrgUrl] = useState('');
    let hideNote = '';
    let countryCode = '';
    let seatAvailability = [];
    const sectionContent = section?.sectionContent;
    // console.log("Section Content : ", sectionContent);
    let priceList = sectionContent[12]?.data;
if (csrData) {
  countryCode = csrData?.result[0]?.queried_country_code;
  forEach(csrData?.result[0]?.tickets, function (data) {
    const el = { data };
    seatAvailability.push(el);
  });
  hideNote = priceList?.find(el => el.country == countryCode);
}
if (hideNote == undefined) {
  hideNote = priceList?.find(el => el.country == 'GB');
}

const cardStyle = {
    Open: {
      boxShadow:
        '0 0 2px #979797',
      background: '#FFFFFF',
    },
    Selected: {
      boxShadow:
        '0px 0px 0px 2px #be3a1d,3.06087px 18.7518px 41px rgba(34, 30, 2, 0.08), 1.98389px 12.154px 24.0116px rgba(34, 30, 2, 0.0607407), 1.179px 7.22293px 13.0593px rgba(34, 30, 2, 0.0485926), 0.612173px 3.75037px 6.6625px rgba(34, 30, 2, 0.04), 0.249404px 1.52793px 3.34074px rgba(34, 30, 2, 0.0314074), 0.0566827px 0.347256px 1.61343px rgba(34, 30, 2, 0.0192593)',
      background: '#F5F0E5',
    },
    Full: {
      outline: 'none',
      boxShadow: 'none',
      background: '#F5F0E5',
    },
  };

  const CustomTab = forwardRef((props, ref) => {
    // 1. Reuse the `useTab` hook
    const tabProps = useTab({ ...props, ref });
    const isSelected = !!tabProps['aria-selected'];

    // 2. Hook into the Tabs `size`, `variant`, props
    const styles = useMultiStyleConfig('Tabs', tabProps);
    const Arrow = () => {
      return (
        <Box
          as="span"
          position="absolute"
          width="20px"
          display={isSelected ? 'block' : 'none'}
          height="11px"
          clipPath="polygon(0 0, 50% 100%, 100% 0)"
          left="50%"
          bottom="-10px"
          background="#CF4520"
          style={{ transition: 'width 1s' }}
          zIndex="0"
          transition="0.4s linear"
        ></Box>
      );
    };

    return (
      <Button
        __css={styles.tab}
        {...tabProps}
        width="50%"
        color={isSelected ? '#FFFFFF !important' : '#474747  !important'}
        bg={isSelected ? '#CF4520' : '#ECECEC'}
        border="0"
        fontFamily="FedraSansStd-book"
        fontStyle="normal"
        fontWeight="600"
        fontSize={pageCss[lang]?.tabTitle?.fontSize}
        lineHeight="150.3%"
        _active={{ bg: '#CF4520', border: '0' }}
        _focus={{ bg: '#CF4520', border: '0' }}
        pos="relative"
        height={{ base: '45px', sm: '105px' }}
        p={{ base: '0', sm: '1rem' }}
        alignItems="center"
      >
        {isSelected ? <Arrow /> : ''}
        {tabProps.children}
      </Button>
    );
  });

const tabDesignHide = sectionContent[3]?.titleDecoration === 'tab-hide' ? true : false;

const Tab1content = () => {
  return (
    <>
    <StructuredTextParser
      str={render(sectionContent[5]?.body)}
      region={region}
      lang={lang}
      fontFamily="FedraSansStd-medium"
      textAlign="center"
      className="textParagraph"
    />
    <Grid
      placeItems="center"
      placeContent="center"
      width="auto"
      mx="auto"
    >
      <FormControl>
          <Flex
            placeContent="center"
            gridGap={{ base: '7px', md: '20px' }}
            gridRowGap={{ base: '30px', md: '30px' }}
            mt="10px"
            maxW="930px"
            flexWrap="wrap"
            flexDirection="row"
          >
            {sectionContent[6]?.data?.map((data, i) => {
              return (
                <Box
                  key={nanoid(4)}
                  w="279px"
                  height="384px"
                  padding="0 0 16px 0"
                  style={
                    onlinePrgUrl === data?.LinkUrl
                      ? cardStyle.Selected
                      : data?.Status === 'Full'
                        ? cardStyle.Full
                        : cardStyle.Open
                  }
                  position="relative"
                  borderRadius="10px"
                  cursor={
                    data?.Status === 'Full' ? 'cursor' : 'pointer'

                  }
                  _hover={{ }}
                >
                  {data.Status === 'Full' && (
                    <Box
                      pos="absolute"
                      top={0}
                      right={0}
                      left={0}
                      bottom={0}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      textAlign="center"
                      background="#494949"
                      opacity="0.7"
                      borderRadius="10px"
                    >
                      <Text
                        color="#fff"
                        fontSize="24px"
                        fontFamily="FedraSansStd-medium"
                      >
                        FULL
                      </Text>
                    </Box>
                  )}
                  <style>
                    {`
                      .radio{
                        border:0 !important;
                        background:transparent !important;
                      }
                      .radio:before{
                        background:#CF4520 !important;
                      }
                      `}
                  </style>
                  <Box marginX={{ base: '0px', md: '0px' }} borderTopLeftRadius="10px" borderTopRightRadius="10px" textAlign="center" height="54px" bgColor="#FFE5B0" display="flex" alignItems="center" justifyContent="center">
                      <Text as="span" fontFamily="FedraSansStd-book" fontSize={{base:'15px', md:'16px'}} color="#41310F" fontWeight="600">
                          {data.CardTitle}
                      </Text>
                  </Box>
                  <Flex justifyContent="space-between" mt="20px" mb="25px">
                      <Box ml="20px" textAlign="left">
                          <Text as="p" fontFamily="FedraSansStd-medium" fontStyle="normal" fontSize={{ base: '22px', md: '22px' }} color="#000000">
                          {data?.Name}
                          </Text>
                          <Text as="p" fontSize="18px" fontWeight="400" mt="10px"><Text as='span' bgColor="#E4DED4" mt="5px" p="6px 10px">{data.NormalPrice}</Text></Text>
                      </Box>
                      <Box marginLeft="auto" mt="5px" mr="20px">
                          <Image src={data?.Seating}/>
                      </Box>
                  </Flex>
                  <Box pl="20px" height="112px">
                    <UnorderedList
                      fontStyle="normal"
                      fontWeight="400"
                      fontSize={{ md: '16px', base: '16px' }}
                      lineHeight={{ md: '22px', base: '22px' }}
                      fontFeatureSettings="case"
                      color="#28231E"
                      fontFamily="FedraSansStd-book"
                    >
                      {data?.Descripton?.value_1 && (
                        <ListItem mb="10px">
                          {parser(data?.Descripton?.value_1 || '')}
                        </ListItem>
                      )}
                      {data?.Descripton?.value_2 && (
                        <ListItem mb="10px">
                          {parser(data?.Descripton?.value_2 || '')}
                        </ListItem>
                      )}
                      {data?.Descripton?.value_3 && (
                        <ListItem mb="10px">
                          {parser(data?.Descripton?.value_3 || '')}
                        </ListItem>
                      )}
                    </UnorderedList>
                  </Box>
                  <Flex placeContent="center" w="100%" mt="20px" mb="16px">
                      <Box d="flex" alignItems="center" m="0" justifyContent="center">
                      <Link
                          href={refineUrlDomain(
                          data?.LinkUrl,
                          region,
                          lang
                          )}
                          mb="0"
                          display="block"
                          fontWeight={'500'}
                          fontFamily={'FedraSansStd-medium'}
                          fontSize={'16px'}
                          bgColor={data?.LinkUrl ? '#cf4520' : 'rgb(207 69 32 / 41%)'}
                          h="48px"
                          textAlign="center"
                          padding={'12px 19px'}
                          borderRadius="4px"
                          color="#faf7f0"
                          textDecoration="none"
                          width={'auto'}
                          minW="240px"
                          minH="48px"
                          cursor={data?.LinkUrl ? 'pointer' : 'not-allowed'}
                          _hover={{
                          bg: data?.LinkUrl ? '#000054' : '',
                          }}
                          target={data?.LinkUrl ? '_blank' : ''}
                      >
                          {data?.CTAButton}
                      </Link>
                      </Box>
                  </Flex>
                </Box>
              );
            })}
          </Flex>
      </FormControl>
    </Grid>
    </>
  )
}
return (
    <Box id={section.sectionId}>
      <Box pt={{ base: '30px', lg: '80px' }} pl={{base:'10px', md:'0'}} pr={{base:'10px', md:'0'}}>
      <SectionTitle titleObj={sectionContent[0]} mt="0px" />
      <Box><HtmlBlock className='prgmdetbullet' sectionContent={sectionContent[1]} /></Box>
      {sectionContent[2]?.image !== null && (
        <Flex justifyContent="center" w="100%">
          <SingleImage
            sectionContent={sectionContent[2]}
            region={region}
            lang={lang}
            my="4"
          />
        </Flex>
      )}
      
      <Box my="1em">
        <StructuredTextParser
          str={render(sectionContent[3]?.body)}
          region={region}
          lang={lang}
          fontSize={{ base: '15px', md: '20px' }}
          color="#000000"
          fontFamily="FedraSansStd-book"
          mt={{base: '20px', md: '40px'}}
          mb={{ base: '20px', md: '40px' }}
          textAlign="Center"
        />
      </Box>

      {sectionContent[4]?.titleDecoration !== 'tab-hide' && (
      <Box w="100%" maxW="1170px" mx="auto">
        <Tabs
          isFitted
          variant="enclosed"
          p="0"
          className="tabcontent"
          border="none"
          borderRadius="12px"
          paddingBottom="20px"
          id="prgTab"
        >
          {!tabDesignHide && (
            <TabList borderBottom="none" mb="25px">
              <CustomTab style={{ borderRadius: '10px 0 0 0' }}>
                {sectionContent[4]?.titleText}
              </CustomTab>
              <CustomTab style={{ borderRadius: '0 10px 0 0' }}>
                {sectionContent[7]?.titleText}
              </CustomTab>
            </TabList>
          )}

          <TabPanels m="0 auto" maxW="930px">
            {sectionContent[4]?.titleDecoration !== 'tab-hide' && (
              <TabPanel>
                <Tab1content/>
              </TabPanel>
            )}
            {/* Tab 2 starts here */}
            <TabPanel>
              {sectionContent[8]?._modelApiKey === 'structured_text' && (
                <StructuredTextParser
                  str={render(sectionContent[8]?.body)}
                  region={region}
                  lang={lang}
                  fontFamily="FedraSansStd-medium"
                  textAlign="center"
                  className="textParagraph"
                />
              )}
              <Grid
                placeItems="center"
                placeContent="center"
                width="auto"
                mx="auto"
              >
                <FormControl>
                  <Flex placeContent="center"
                    gridGap={{ base: '7px', md: '20px' }}
                    gridRowGap={{ base: '15px', md: '30px' }}
                    mt="10px"
                    maxW="930px"
                    flexWrap="wrap"
                    flexDirection="row"
                  >
                        {sectionContent[9]?.data?.map((data, i) => {
                          return (
                            <Box
                              key={nanoid(4)}
                              w="279px"
                              height="384px"
                              padding="0 0 16px 0"
                              style={
                                onlinePrgUrl === data?.LinkUrl
                                  ? cardStyle.Selected
                                  : data?.Status === 'Full'
                                    ? cardStyle.Full
                                    : cardStyle.Open
                              }
                              position="relative"
                              borderRadius="10px"
                              cursor={
                                data?.Status === 'Full' ? 'cursor' : 'pointer'

                              }
                              _hover={{ }}
                            >
                              {data?.Status === 'Full' && (
                                <Box
                                  pos="absolute"
                                  top={0}
                                  right={0}
                                  left={0}
                                  bottom={0}
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="center"
                                  textAlign="center"
                                  background="#494949"
                                  opacity="0.7"
                                  borderRadius="10px"
                                >
                                  <Text
                                    color="#fff"
                                    fontSize="24px"
                                    fontFamily="FedraSansStd-medium"
                                  >
                                    FULL
                                  </Text>
                                </Box>
                              )}
                              <Box marginX={{ base: '0px', md: '0px' }} borderTopLeftRadius="10px" borderTopRightRadius="10px" textAlign="center" height="54px" bgColor="#FFE5B0" display="flex" alignItems="center" justifyContent="center">
                                  <Text as="span" fontSize="16px" color="#41310F" fontWeight="600">
                                      {data?.CardTitle}
                                  </Text>
                              </Box>
                              <Flex justifyContent="space-between" mt="20px" mb="25px">
                                  <Box ml="20px" textAlign="left">
                                      <Text as="p" fontFamily="FedraSansStd-medium" fontStyle="normal" fontSize={{ base: '22px', md: '22px' }} color="#000000">
                                      {data?.Name}
                                      </Text>
                                      <Text as="p" fontSize="18px" fontWeight="400" mt="10px"><Text as='span' bgColor="#E4DED4" mt="5px" p="6px 10px">{data.NormalPrice}</Text></Text>
                                  </Box>
                                  <Box marginLeft="auto" mt="5px" mr="20px">
                                      <Image src={data?.Seating}/>
                                  </Box>
                              </Flex>
                              <Box pl="20px" height="112px">
                                <UnorderedList
                                  fontStyle="normal"
                                  fontWeight="400"
                                  fontSize={{ md: '16px', base: '16px' }}
                                  lineHeight={{ md: '22px', base: '22px' }}
                                  fontFeatureSettings="case"
                                  color="#28231E"
                                  fontFamily="FedraSansStd-book"
                                >
                                  {data?.Descripton?.value_1 && (
                                    <ListItem mb="10px">
                                      {parser(data.Descripton?.value_1 || '')}
                                    </ListItem>
                                  )}
                                  {data.Descripton?.value_2 && (
                                    <ListItem mb="10px">
                                      {parser(data.Descripton?.value_2 || '')}
                                    </ListItem>
                                  )}
                                  {data.Descripton?.value_3 && (
                                    <ListItem mb="10px">
                                      {parser(data.Descripton?.value_3 || '')}
                                    </ListItem>
                                  )}
                                </UnorderedList>
                              </Box>
                              <Flex placeContent="center" w="100%" mt="20px" mb="16px">
                                  <Box d="flex" alignItems="center" m="0" justifyContent="center">
                                  <Link
                                      href={refineUrlDomain(
                                      data?.LinkUrl,
                                      region,
                                      lang
                                      )}
                                      mb="0"
                                      display="block"
                                      fontWeight={'500'}
                                      fontFamily={'FedraSansStd-medium'}
                                      fontSize={'16px'}
                                      bgColor={data?.LinkUrl ? '#cf4520' : 'rgb(207 69 32 / 41%)'}
                                      h="48px"
                                      textAlign="center"
                                      padding={'12px 19px'}
                                      borderRadius="4px"
                                      color="#faf7f0"
                                      textDecoration="none"
                                      width={'auto'}
                                      minW="240px"
                                      minH="48px"
                                      cursor={data?.LinkUrl ? 'pointer' : 'not-allowed'}
                                      _hover={{
                                      bg: data?.LinkUrl ? '#000054' : '',
                                      }}
                                      target={data?.LinkUrl ? '_blank' : ''}
                                  >
                                      {data?.CTAButton}
                                  </Link>
                                  </Box>
                              </Flex>
                            </Box>
                          );
                        })}
                  </Flex>
                </FormControl>
              </Grid>
              <MidContainer w={'768'}>
                <StructuredTextParser
                  str={render(sectionContent[6]?.body)}
                  region={region}
                  lang={lang}
                  mt="30px"
                  className="programDetailsText"
                  textAlign="center"
                />
                {sectionContent[16]?._modelApiKey === 'simple_button' && (
                  <Box display="flex" placeContent="center" mt="40px">
                    <Link
                      href={refineUrlDomain(prgUrl, region, lang)}
                      mb="30px"
                      display="block"
                      fontWeight={'500'}
                      fontFamily={'FedraSansStd-medium'}
                      fontSize={'18px'}
                      bgColor={prgUrl ? '#cf4520' : '#cf452069'}
                      h={'auto'}
                      minH="50px"
                      textAlign="left"
                      padding={'14px 29px'}
                      borderRadius="5px"
                      color="#faf7f0"
                      textDecoration="none"
                      width={'auto'}
                      cursor={prgUrl ? 'pointer' : 'not-allowed'}
                      _hover={{
                        bg: prgUrl ? '#000054' : '',
                      }}
                      target={prgUrl ? '_blank' : ''}
                    >
                      {sectionContent[16]?.buttonText}
                    </Link>
                  </Box>
                )}
              </MidContainer>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
      )}
      {/* single tab */}
      {sectionContent[4]?.titleDecoration === 'tab-hide' && sectionContent[7]?.titleDecoration === 'tab-hide' && (
          <Box m="0 auto" maxW="930px">
            <Tab1content/>
          </Box>
        )}
      <style jsx global>
        {`
          .textParagraph p {
            font-size: 18px;
            color: #be3a1d;
            text-transform: uppercase;
          }
          .textParagraph p:nth-child(2) {
            font-size: 16px;
            color: #28231e;
            text-transform: none;
            font-family: 'FedraSansStd-book';
          }
          .programDetailsText p{
            font-size:18px;
          }
          .linkText p a {
            text-decoration: underline;
          }
          .prgmdetbullet {
            display: block;
            margin: 20px auto 10px auto;
            line-height: 30px;
            padding-left: 20px;
          }
          .prgmdetbullet ul {
            margin: 0 auto;
            display: block !important;
            width: auto;
            font-size: 18px;
            max-width: 50%;
            margin: 0 auto;
          }
          .prgmdetbullet li {
            margin-bottom: 24px;
            position: relative;
            padding-left: 10px;
          }
          .prgmdetbullet ul li img {
            position: absolute !important;
            left: -30px;
            background: white;
            padding-right: 5px;
            margin-top: 5px;
          }
          @media screen and (max-width: 450px) {
            .programDetailsText{
              text-align:left;
            }
            .programDetailsText p{
              font-size:14px !important;
            }
            .programDetailsText strong{
              font-size:14px !important;
            }
            .prgmdetbullet ul {
              columns: 1;
              -webkit-columns: 1;
              font-size: 16px;
              -moz-columns: 1;
              padding-left: 21px;
            }
            .prgmdetbullet li {
              line-height: 24px;
              margin-bottom: 21px;
            }
            .prgmdetbullet ul li img {
              position: absolute !important;
              left: -25px;
              background: white;
              padding-right: 5px;
            }
          }
        `}
      </style>
      </Box >
    </Box>
  );
};

export default ProgramCategory;